export default "__VITE_ASSET__CM3bIF65__"